import styled from "styled-components";

export const Modal = styled.div`
  z-index: 3;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.2);
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 300px;
  background-color: #fff;
  box-shadow: 2px 4px 2px rgba(0, 0, 0, 0.5);
  border-radius: 10px;

  @media (max-width: 820px) {
    width: 90%;
  }
`;

export const Close = styled.div`
  position: absolute;
  top: 15px;
  right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  border: 1px solid #000;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`;

export const TextQuestion = styled.p`
  font-size: 16px;
  font-weight: 600;
  text-align: center;
`;

export const ContainerButtons = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 50%;
  height: 60px;
`;
